import { render, staticRenderFns } from "./MetricLink.vue?vue&type=template&id=4dcba474&scoped=true"
import script from "./MetricLink.vue?vue&type=script&lang=js"
export * from "./MetricLink.vue?vue&type=script&lang=js"
import style0 from "./MetricLink.vue?vue&type=style&index=0&id=4dcba474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcba474",
  null
  
)

export default component.exports